import React from "react";
import AutoMode from "@mui/icons-material/AutoMode";
import SupervisorAccountOutlined from "@mui/icons-material/SupervisorAccountOutlined";
import "../styles/demo-mode.css";

export default function DemoModeControl({ value, onChange, label }) {
  return (
    <div
      className="demo-mode"
      role="group"
      aria-label={label + " execution mode"}
    >
      <button
        type="button"
        aria-pressed={value === "supervised"}
        onClick={() => onChange("supervised")}
        title="Supervised: pause at review checkpoints"
      >
        <SupervisorAccountOutlined />
        <span>Supervised</span>
      </button>
      <button
        type="button"
        aria-pressed={value === "autonomous"}
        onClick={() => onChange("autonomous")}
        title="Autonomous: continue within delegated permissions; escalate exceptions"
      >
        <AutoMode />
        <span>Autonomous</span>
      </button>
    </div>
  );
}
